"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var PaymentStyles_1 = require("./PaymentStyles");
var paymentApi_1 = require("../../../../common/api/paymentApi");
var useAppContext_1 = require("../../../../common/react/useAppContext");
var SubaruLogo_png_1 = require("../../../../common/assets/images/SubaruLogo.png");
var BMWLogo_png_1 = require("../../../../common/assets/images/BMWLogo.png");
var PaymentProviderVisaNet_1 = require("./PaymentProviderVisaNet");
var DefaultText_1 = require("../../staticText/DefaultText");
var TransactionErrorTypes_1 = require("../../../../common/enum/TransactionErrorTypes");
var useDealErrorHandler_1 = require("../../../../common/react/useDealErrorHandler");
var useDealStatusAssertion_1 = require("../../../../common/react/useDealStatusAssertion");
var JourneyTypes_1 = require("../../../../../../common/enum/JourneyTypes");
var errorMessageHoc_1 = require("../../../../common/components/presentation/Error/errorMessageHoc");
var MinimalLoader_1 = require("../../../../common/components/presentation/MinimalLoader/MinimalLoader");
var PaymentErrorText_1 = require("../../staticText/PaymentErrorText");
var dimensions_1 = require("../../../../../../common/constants/dimensions");
var dealApi_1 = require("../../../../common/api/dealApi");
var PaymentVisaNet = function (_a) {
    var _b;
    var componentHandleError = _a.componentHandleError;
    var _c;
    var style = PaymentStyles_1.default();
    var _d = useAppContext_1.default(), setDeal = _d.setDeal, _e = _d.deal, brand = _e.brand, payment = _e.payment, transactionError = _d.transactionError;
    var reservation = core_1.useTheme().checkoutLite.reservation;
    var handleDealError = useDealErrorHandler_1.default();
    var parentNodeId = react_1.useState('wrapper:checkout:paymentProvider')[0];
    var _f = react_1.useState(null), paymentData = _f[0], setPaymentData = _f[1];
    var _g = react_1.useState(true), isLoading = _g[0], setIsLoading = _g[1];
    var getStatusCode = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var paymentAccessCode, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    return [4 /*yield*/, paymentApi_1.default.getAccessCode()];
                case 1:
                    paymentAccessCode = _a.sent();
                    setPaymentData(paymentAccessCode.data);
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    componentHandleError(handleDealError(error_1));
                    return [3 /*break*/, 4];
                case 3:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [handleDealError]);
    var getDeal = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var dealOnError, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dealApi_1.default.getDeal()];
                case 1:
                    dealOnError = _a.sent();
                    if (dealOnError.data) {
                        data = dealOnError.data;
                        setDeal(data);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [transactionError]);
    var renderPaymentSection = react_1.useCallback(function () {
        if (isLoading) {
            return;
        }
        var merchantLogo = SubaruLogo_png_1.default;
        if (brand === dimensions_1.dimensions.BRAND.BMW_DIS) {
            merchantLogo = BMWLogo_png_1.default;
        }
        return PaymentProviderVisaNet_1.default({
            parentNodeId: parentNodeId,
            merchantLogo: merchantLogo,
            paymentData: paymentData,
            className: style.visaNetForm,
        }).catch(componentHandleError);
    }, [isLoading, paymentData]);
    useDealStatusAssertion_1.default((_b = {},
        _b[JourneyTypes_1.JourneyTypes.RESERVE_ONLINE] = 3100,
        _b[JourneyTypes_1.JourneyTypes.CONTINUE_IN_DEALERSHIP] = false,
        _b[JourneyTypes_1.JourneyTypes.ORDER_ONLINE] = false,
        _b));
    react_1.useEffect(function () {
        getStatusCode();
    }, []);
    react_1.useEffect(function () {
        renderPaymentSection();
    }, [renderPaymentSection]);
    react_1.useEffect(function () {
        if (transactionError === TransactionErrorTypes_1.TransactionErrorTypes.FAILED) {
            getDeal();
        }
    }, [transactionError]);
    return (<>
      {transactionError === TransactionErrorTypes_1.TransactionErrorTypes.NONE ? (<DefaultText_1.default paymentData={paymentData} style={style}/>) : (<PaymentErrorText_1.default style={style} paymentData={((_c = reservation) === null || _c === void 0 ? void 0 : _c.showCardDetailsOnError) ? payment : null}/>)}
      <core_1.Box data-test={parentNodeId} className={[style.paymentButtonWrapper, !isLoading && style.alignCenter].join(' ')}>
        {isLoading && <MinimalLoader_1.default />}
      </core_1.Box>
    </>);
};
exports.default = errorMessageHoc_1.default(PaymentVisaNet);
